import { RootState } from '@app/redux/root-reducer';

export const selectAttributesState = (store: RootState) => store.attributeSlice.attributes;
export const selectAddAttributeState = (store: RootState) => store.attributeSlice.addAttribute;
export const selectDeleteAttributeState = (store: RootState) =>
  store.attributeSlice.attributeDelete;
